<template>
  <div class="container">
    <table class="table">
        <th v-if="isHeader">

        </th>

      <tbody class="client-info">
          <tr v-for="(client, index) in rowData" :key="index">
              <td>{{rowData.name}}</td>
              <td>{{rowData.surname}}</td>
          </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
    }
  },
  computed: {
    cname: {
      get () {
        return this.name
      },
      set (name) {
        this.name = name
      },
    },
  },
  props: ['rowData', 'index', 'fields'],
  methods: {
    itemAction: function (action, rowData, field) {
      console.log(rowData)
      this.cname = action

      console.log(field)
    },
  },
}
</script>

<style scoped>
.modalGridInput {
  margin-right: .5%;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>
